import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { toggleFacetInFilterBy, addUniqFacetInFilterBy } from '~/helpers/filter-helper';
import * as types from './types';
export default {
  [types.SET_DEFAULT_ORDERBY](state, payload) {
    var currentState = state;
    currentState.orderBy = payload;
  },

  [types.SET_DEFAULT_SORTBY](state, payload) {
    var currentState = state;
    currentState.sortBy = payload;
  },

  [types.SET_DEFAULT_FILTERBY](state, payload) {
    var currentState = state;
    currentState.filterBy = payload;
  },

  [types.SORT_BY](state, payload) {
    var currentState = state;
    currentState.sortBy = payload;
  },

  [types.ORDER_BY](state, payload) {
    var currentState = state;
    currentState.orderBy = payload;
  },

  [types.FILTER_BY](state, _ref) {
    var {
      filter,
      facet,
      uniq = false
    } = _ref;
    var currentState = state;
    var transform = uniq ? addUniqFacetInFilterBy : toggleFacetInFilterBy;
    currentState.filterBy = transform(_objectSpread({}, currentState.filterBy), filter, facet);
  },

  [types.RESET_FILTERS](state) {
    var currentState = state;
    currentState.filterBy = null;
  },

  [types.RESET_PAGINATION](state) {
    var currentState = state;
    currentState.previousPage = 1;
    currentState.nextPage = 1;
  },

  [types.SET_NEXT_PAGE](state, payload) {
    var currentState = state;
    currentState.nextPage = payload;
  },

  [types.SET_PREVIOUS_PAGE](state, payload) {
    var currentState = state;
    currentState.previousPage = payload;
  }

};